import { getAPIPath, requestPawGressReportGooseAPI } from '../shared/request'
import { CLIENT_REPORT_CARD_LIST_BY_ID_PET_PATH } from '../types/constants'
import { ReportCard } from '../types/reportCards'

export const ClientReportCardListService = {
  getReportCardListByPetId: (locationName: string, petId: string, params?: { limit: number }) => {
    return requestPawGressReportGooseAPI<ReportCard[]>({
      url: getAPIPath(CLIENT_REPORT_CARD_LIST_BY_ID_PET_PATH, { locationId: locationName, petId }),
      method: 'GET',
      params,
    })
  },
}
